import { Link } from "react-router-dom";

const AiContentGeneratorWork = () => {
  return (
    <>
      <div className="ail-work-area pt-120 pb-60">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-9">
              <div className="text-center mb-30">
                <p className="ail-sub-title text-black fw-500 ah-input-bg d-inline-flex align-items-center gap-2 rounded-5 mb-20">
                  <span className="ail-gd-bg"></span> How it works
                </p>
                <h2 className="ail-title text-black fs-48 fw-600">
                  Just give your keywords and watch them{" "}
                  <span className="ail-highlighted-text">
                    generate your copy
                  </span>
                  .
                </h2>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="ail-step-sub-title d-flex align-items-center gap-3 mb-20">
                <span className="bg-black"></span>
                <p className="ca-two-body-clr ff-poppins fw-600 mb-0">
                  Step 01
                </p>
              </div>
              <h3 className="text-black fs-36">
                Select writing template Content Creation at Scale
              </h3>
              <p className="mb-20">
                Marve has the answer to every request and is using the latest
                Google Data for accurate responses.
              </p>
              <ul className="ail-work-list list-unstyled">
                <li className="d-flex gap-3">
                  <svg
                    className="mt-5-ov"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.3"
                      d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                      fill="#6672FB"
                    />
                    <path
                      d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                      fill="#476EFB"
                    />
                  </svg>
                  <div className="ail-work__content">
                    <p className="text-black fw-700 mb-0">
                      The Creative Art maker
                    </p>
                    <p className="fch-40 mb-0">
                      The bee's knees cracking goal it's all gone topot old
                      young delinquent.
                    </p>
                  </div>
                </li>
                <li className="d-flex gap-3 mt-20">
                  <svg
                    className="mt-5-ov"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.3"
                      d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                      fill="#6672FB"
                    />
                    <path
                      d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                      fill="#476EFB"
                    />
                  </svg>
                  <div className="ail-work__content">
                    <p className="text-black fw-700 mb-0">
                      The Creative Art maker
                    </p>
                    <p className="fch-40 mb-0">
                      The bee's knees cracking goal it's all gone topot old
                      young delinquent.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="ail-gd-bg-2 p-4 pt-40 pb-40 rounded-16">
                <img
                  src="assets/img/ail_home/work-1.png"
                  alt=""
                  className="w-100 img-fluid"
                />
              </div>
            </div>
          </div>
          <div className="mt-50">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="ail-gd-bg-3 p-4 pt-40 pb-40 rounded-16">
                  <img
                    src="assets/img/ail_home/work-2.png"
                    alt=""
                    className="w-100 img-fluid rounded-16"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="pl-40">
                  <div className="ail-step-sub-title d-flex align-items-center gap-3 mb-20">
                    <span className="bg-black"></span>
                    <p className="ca-two-body-clr ff-poppins fw-600 mb-0">
                      Step 02
                    </p>
                  </div>
                  <h3 className="text-black fs-36">
                    Describe your topic & Create fresh content
                  </h3>
                  <p className="mb-20">
                    Marve has the answer to every request and is using the
                    latest Google Data for accurate responses.
                  </p>
                  <h6 className="text-black fs-18">
                    Prompt Library - AI for Community
                  </h6>
                  <p className="mb-20">
                    Monotonectally engineer multidisciplinary systems vis-a-vis
                    mission-critical partnerships. Holisticly architect
                    web-enabled web
                  </p>
                  <ul className="ail-work-list list-unstyled d-flex align-items-center gap-4 flex-wrap">
                    <li className="d-flex gap-3">
                      <svg
                        className="mt-5-ov"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                          fill="#6672FB"
                        />
                        <path
                          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                          fill="#476EFB"
                        />
                      </svg>
                      <div className="ail-work__content">
                        <p className="text-black fw-700 mb-0">
                          The Creative Art maker
                        </p>
                      </div>
                    </li>
                    <li className="d-flex gap-3">
                      <svg
                        className="mt-5-ov"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                          fill="#6672FB"
                        />
                        <path
                          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                          fill="#476EFB"
                        />
                      </svg>
                      <div className="ail-work__content">
                        <p className="text-black fw-700 mb-0">
                          The Creative Art maker
                        </p>
                      </div>
                    </li>
                  </ul>
                  <Link
                    href="/ai-content-generator"
                    className="btn ail-gd-bg dark-bg-hover rounded-5 text-white fs-16 border-0 mt-20"
                  >
                    Try It Free Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-40">
            <div className="ail-main-bg p-5 rounded-16">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="ail-step-sub-title d-flex align-items-center gap-3 mb-20">
                    <span className="bg-black"></span>
                    <p className="ca-two-body-clr ff-poppins fw-600 mb-0">
                      Final Step
                    </p>
                  </div>
                  <h3 className="text-black fs-36">
                    Select writing template Content Creation at Scale
                  </h3>
                  <p className="mb-20">
                    Marve has the answer to every request and is using the
                    latest Google Data for accurate responses.
                  </p>
                  <h6 className="text-black fs-18">
                    Prompt Library - AI for Community
                  </h6>
                  <ul className="ail-work-list list-unstyled">
                    <li className="d-flex gap-3">
                      <svg
                        className="mt-5-ov"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                          fill="#6672FB"
                        ></path>
                        <path
                          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                          fill="#476EFB"
                        ></path>
                      </svg>
                      <div className="ail-work__content">
                        <p className="fch-40 mb-0">
                          The bee's knees cracking goal it's all gone topot old
                          young delinquent.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <div className="pl-15">
                    <div className="bg-sky-blue p-4 rounded-16">
                      <img
                        src="assets/img/ail_home/work-3.png"
                        alt=""
                        className="w-100 img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiContentGeneratorWork;
